import React from "react";
import {
  Image,
  ImageWrapper,
  LicenceCell,
  Overlay,
  TitleText,
  ZoomIcon,
} from "../LicencesSection/LicencesSection.styled";
import { Box } from "@mui/material";

interface LicenceCardProps {
  title: string;
  imageUrl: string;
  pdfLink: string;
  isLastColumn: boolean;
  isLastRow: boolean;
}
const LicenceCard: React.FC<LicenceCardProps> = ({
  title,
  imageUrl,
  pdfLink,
  isLastColumn,
  isLastRow,
}) => {
  return (
    <LicenceCell isLastColumn={isLastColumn} isLastRow={isLastRow}>
      <Box>
        <TitleText>{title}</TitleText>
      </Box>
      <ImageWrapper onClick={() => window.open(pdfLink, "_blank")}>
        <Image src={imageUrl} alt={title} />
        <Overlay>
          <ZoomIcon />
        </Overlay>
      </ImageWrapper>
    </LicenceCell>
  );
};

export default LicenceCard;
